import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import BaseLabel from "components/BaseLabel";

import { InputGeneral } from "../../../../../components/Input";

interface ProcedureMaskProps {
  setEditedValue: (value: string) => void;
  editedValue: string;
}

const ProcedureMask = ({ setEditedValue, editedValue }: ProcedureMaskProps) => {
  const { t } = useTranslation();
  const handleChange = (value: string) => {
    setEditedValue(value);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <BaseLabel
          fontSize="18px"
          fontWeight="700"
          marginBottom="0px"
          marginTop="0px"
          marginLeft="0px"
          marginRight="0px"
        >
          {t("systemConfiguration.procedureMask.title")}
        </BaseLabel>
      </Grid>
      <Grid item xs={12}>
        <InputGeneral
          label={t("systemConfiguration.procedureMask.description")}
          value={editedValue}
          placeholder="ex: 999.999.999-99"
          onChange={(e) => handleChange(e)}
          required={false}
          error={false}
          width={381}
          maxLength={499}
          id="name_attendant"
          type="text"
        />
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            backgroundColor: "#f2f2f2",
            borderRadius: "4px",
            padding: "8px 12px",
          }}
        >
          <BaseLabel
            fontSize="12px"
            fontWeight="400"
            marginTop="0px"
            marginBottom="0px"
          >
            <span>
              {t("systemConfiguration.procedureMask.examples")}
              <br />
              G-999999
              <br />
              9999-9999-9999/9999
              <br />
              99-99-9999
            </span>
          </BaseLabel>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ProcedureMask;
